export const itemClassMap = {
  'A': 'Antique',
  'C+RH': 'Curio & Relic Handgun',
  'C+RL': 'Curio & Relic Long Gun',
  'C+RO': 'Curio & Relic Other',
  'III': 'Class III',
  'MH': 'Modern Handgun',
  'ML': 'Modern Long Gun',
  'MO': 'Modern Other',
  'O': 'Other',
};
